import { Center, HStack, IconButton, Stack, Text } from '@chakra-ui/react';
import { PageHeading } from '@duke-hq/ui/components/PageHeading';
import { useSubSidebar } from '@duke-hq/ui/components/SubSidebar/useSubSidebar';
import { Trans } from '@lingui/react/macro';
import { ArrowRightFromLine } from 'lucide-react';

interface ComingSoonProps {
  title: React.ReactNode;
}

export function ComingSoon({ title }: ComingSoonProps): React.JSX.Element {
  const { isExpanded, toggleExpandSubSidebar } = useSubSidebar();
  return (
    <Stack p={6} gap={4}>
      <HStack gap={3}>
        {!isExpanded && (
          <IconButton
            aria-label="expand secondary sidebar"
            variant="tertiary"
            onClick={toggleExpandSubSidebar}
            size="md"
            icon={<ArrowRightFromLine />}
          />
        )}
        <PageHeading>{title}</PageHeading>
      </HStack>
      <Center p={12}>
        <Text fontSize="lg" color="fg.subtle">
          <Trans>Coming soon</Trans>
        </Text>
      </Center>
    </Stack>
  );
}
